import { Box, makeStyles, Tooltip } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import ErrorIcon from "@material-ui/icons/Error";
import UpdateIcon from "@material-ui/icons/Update";

export interface ItemKeyValidationDetails {
  value: any;
  lastValue: any;
  status: string;
  errorMessage?: string;
}

function renderValue(v: any) {
  if (typeof v === "boolean") {
    return String(v);
  }
  return v;
}

const useCellStyles = makeStyles((t) => ({
  icon: {
    marginRight: t.spacing(1),
  },
}));

const ValidationTableCell: FC<ItemKeyValidationDetails> = ({
  status,
  value,
  lastValue,
  errorMessage,
}) => {
  const classes = useCellStyles();

  const statusMap = {
    DELETION: {
      icon: <DeleteIcon className={classes.icon} />,
      tooltipMessage: "Deleted",
    },
    ADDITION: {
      icon: <AddIcon className={classes.icon} />,
      tooltipMessage: "Added",
    },
    UPDATE: {
      icon: <UpdateIcon className={classes.icon} />,
      tooltipMessage: `Updated from: "${renderValue(lastValue)}"`,
    },
  };

  let { icon } = statusMap[status] || {};
  const { tooltipMessage } = statusMap[status] || {};
  const toolTipMessages = tooltipMessage ? [tooltipMessage] : [];

  if (errorMessage) {
    icon = <ErrorIcon className={classes.icon} />;
    toolTipMessages.push(`Error: ${errorMessage}`);
  }

  const tooltipValue = toolTipMessages.join(",\n") || "No changes";

  return (
    <Tooltip title={tooltipValue}>
      <Box display="flex" justifyContent="center" alignItems="center">
        {icon}
        <div>{renderValue(value)}</div>
      </Box>
    </Tooltip>
  );
};

export default ValidationTableCell;
